import { Box, Card, Grid, styled, Typography, Stack } from '@mui/material'
import { type InterestedService } from 'core/types'
import S3Image from 'Components/S3Image'
import DateRangeIcon from '@mui/icons-material/DateRange'
import ScheduleIcon from '@mui/icons-material/Schedule'

const StyledCard = styled(Card)(`
padding-right:10px;
  box-shadow:none;
`)
interface InterestFormCardProps {
  notes: string
  services: InterestedService[]
  onClick: () => void
}
export function InterestFormCard (props: InterestFormCardProps): JSX.Element {
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
  //   setAnchorEl(event.currentTarget)
  // }

  return <StyledCard>
    {/* <Popover
      id={'intakeCardPopover'}
      open={anchorEl != null}
      anchorEl={anchorEl}
      onClose={() => { setAnchorEl(null) }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
    >
      <MenuList>
        <MenuItem onClick={props.onClick}>
          <ListItemText>Dismiss</ListItemText>
        </MenuItem>
      </MenuList>
    </Popover> */}

    <Grid container sx={{ width: '100%', height: '100%', p: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {props.notes != null && props.notes !== '' && (<>
        <Grid item>
          <Typography variant='h6'>Child Notes</Typography>
        </Grid>
        <Grid item sx={{ width: '100%', overflowWrap: 'break-word' }}>{props.notes}</Grid>
      </>)}
      {props.services.length > 0 && (<>
        <Grid item>
          <Typography variant='h6'>Services Requested</Typography>
        </Grid>
        {props.services.map(s => {
          return <Grid item>
            <Box sx={{ display: 'flex', flexDirection: 'row', border: '1px solid gainsboro', borderRadius: '8px', padding: '8px', gap: 1 }}>
              <Stack direction='column' gap={1.5}>
                <Stack direction='row' gap={1} >
                  {s.s3Key != null && s.s3Key !== '' && (
                    <S3Image alt={`${s.name}-service-image`} imageKey={s.s3Key} style={{ height: '20px', width: '20px' }} />
                  )}
                  <Box>{s.name}</Box>
                </Stack>
                {s.timeSpan != null && (
                  <Stack direction='row' gap={1}>
                    <DateRangeIcon />
                    <Box>{s.timeSpan}</Box>
                  </Stack>
                )}
                {s.desiredSchedule != null && (
                  <Stack direction='row' gap={1}>
                    <ScheduleIcon />
                    <Box>{s.desiredSchedule}</Box>
                  </Stack>
                )}
              </Stack>
            </Box>
          </Grid>
        })}

      </>)}
    </Grid>
  </StyledCard>
}
